import Spinner from './Spinner';

// Gedeelde laad/fout/leeg-gate. Toont in volgorde: spinner tijdens `loading`,
// de foutregel bij `error`, het `empty`-blok als dat meegegeven én truthy is,
// anders de children. `loadingText` stuurt de spinnertekst; `spinner` vervangt
// de hele spinner-node; `errorStyle` overschrijft de foutstijl per call-site
// zodat het uiterlijk exact gelijk blijft.
export default function AsyncBoundary({ loading, error, empty, loadingText, spinner, errorStyle, children }) {
  if (loading) return spinner ?? <Spinner text={loadingText} />;
  if (error)   return <div role="alert" className="rounded-md border border-red-500/25 bg-red-100 text-red-600 text-[15px] p-4" style={errorStyle}>Gegevens laden is niet gelukt. Probeer het opnieuw. <span className="text-[14px]">({error})</span></div>;
  if (empty)   return empty;
  return children;
}
